import { Pipe } from '@angular/core';
import { isObject } from '../helpers/helpers';
var PairsPipe = (function () {
    function PairsPipe() {
    }
    PairsPipe.prototype.transform = function (obj) {
        if (Array.isArray(obj) || !isObject(obj)) {
            return obj;
        }
        return Object.keys(obj).map(function (k) { return [k, obj[k]]; });
    };
    PairsPipe.decorators = [
        { type: Pipe, args: [{ name: 'pairs' },] },
    ];
    /** @nocollapse */
    PairsPipe.ctorParameters = function () { return []; };
    return PairsPipe;
}());
export { PairsPipe };
//# sourceMappingURL=pairs.js.map


//////////////////
// WEBPACK FOOTER
// ./~/ngx-pipes/esm/pipes/object/pairs.js
// module id = 274
// module chunks = 4